import {Store} from "vuex";
import {Resource} from "@k/global/resourcemanager/resource";
import {ColorUtils} from "@k/js/colorUtils";
import {EventListener} from "@k/global/eventVerteiler";
import {EnumDictionary} from "@k/js/delme_globals";
import {Ref, ref} from "vue";
import {ColorUtilsVue} from "@km/js/ColorUtilsVue";
import {PalettenEintragFromDBWithFarbgruppenEinteilung} from "@k/js/databaseInterfaceClasses";

export function getColorName(store:Store<any>, palettenClustername, palettenName, colorValueInt) {
    const palettenClusterResource = store.getters.getResourceByName("palettenCluster_"+palettenClustername);
    if(palettenClusterResource === null) {
        return "";
    }
    if(palettenName === null) {
        palettenName = ColorUtilsVue.getPaletteForColorValueFromCluster(colorValueInt, palettenClusterResource.data)
    }
    const palette = (palettenClusterResource as Resource).data[palettenName];
    if(!palette) {
        return "";
    }
    const color = palette.find((c:PalettenEintragFromDBWithFarbgruppenEinteilung)=>c.RGBHex === ColorUtils.decToHex(colorValueInt));
    if(!color) {
        return "";
    }
    return color.NameImWeb;
}

export class PatternPreviewImageHolder extends EventListener {

    private static previevImages = {} as EnumDictionary<number, Ref<string|null>>

    public constructor() {
        super();
        this.addEventListener("PreviewSVGCreatedEvent", (data:{svg:string, colorCodeNr:number})=>{
            if(PatternPreviewImageHolder.previevImages[data.colorCodeNr] === undefined) {
                PatternPreviewImageHolder.previevImages[data.colorCodeNr] = ref(data.svg);
            } else {
                PatternPreviewImageHolder.previevImages[data.colorCodeNr].value = data.svg;
            }

        })
    }

    public static getPreviewImage(forColorCodeNr:number) {
        if(typeof(PatternPreviewImageHolder.previevImages[forColorCodeNr]) ==="undefined") {
            PatternPreviewImageHolder.previevImages[forColorCodeNr] = ref(null);
        }
        return PatternPreviewImageHolder.previevImages[forColorCodeNr];
    }
}
